import { AuthUserPerfilId } from '../store/modules/auth/IAuthUserPerfil';

export const allProfileIds: AuthUserPerfilId[] = [
  AuthUserPerfilId.PertencerChat,
  AuthUserPerfilId.PertencerAdmin,
  AuthUserPerfilId.PertencerConsulta,
  AuthUserPerfilId.PertencerGestao,
  AuthUserPerfilId.Associado,
  AuthUserPerfilId.AssociadoConvidado,
  AuthUserPerfilId.Deslogado,
  AuthUserPerfilId.Representante,
];

export const allPertencerProfileIds: AuthUserPerfilId[] = [
  AuthUserPerfilId.PertencerChat,
  AuthUserPerfilId.PertencerAdmin,
  AuthUserPerfilId.PertencerConsulta,
  AuthUserPerfilId.PertencerGestao,
];

export const allAssociadoProfileIds: AuthUserPerfilId[] = [
  AuthUserPerfilId.Associado,
  AuthUserPerfilId.AssociadoConvidado,
];
